import React from 'react';
import {
	hasOfertaFromExternalContent,
	isCallCenterForm,
	isCallMeForm,
	isSolucionesEstandarizadasForm,
} from '../../helpers/form-helpers';
import { CallCenterForm } from './call-me/call-center-form';
import { CallMeForm } from './call-me/call-me-form';
import { LeadVentaForm } from './lead-venta-form';
import { LeadVentaOfertaForm } from './lead-venta-oferta-form';
import { SolucionesEstandarizadasForm } from './soluciones-estandarizadas/soluciones-estandarizadas-form';

export const LeadVentaController = () => {
	if (isCallMeForm()) {
		return <CallMeForm />;
	}
	if (isCallCenterForm()) {
		return <CallCenterForm />;
	}
	if (isSolucionesEstandarizadasForm()) {
		return <SolucionesEstandarizadasForm />;
	}
	if (hasOfertaFromExternalContent()) {
		return <LeadVentaOfertaForm />;
	}

	return <LeadVentaForm />;
};
